package org.vreo.devicehub.features.liveAccess.presentation.components

import org.vreo.devicehub.features.liveAccess.domain.WebRtcConnectMode
import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.webrtc_connection_mode_normal
import devicehub.composeapp.generated.resources.webrtc_connection_mode_private_turn_server
import org.vreo.devicehub.features.core.presentation.UiText

/**
 * Convert [WebRtcConnectMode] to [UiText]
 */
fun WebRtcConnectMode.toUiText(): UiText {
    val stringRes = when (this) {
        WebRtcConnectMode.NORMAL -> Res.string.webrtc_connection_mode_normal
        WebRtcConnectMode.PRIVATE_TURN_SERVER -> Res.string.webrtc_connection_mode_private_turn_server
    }
    return UiText.StringResourceId(stringRes)
}